import {Injectable} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '@services/auth.service';
import {UserNamespace} from '@namespaces/user.namespace';

/**
 * Проверка соответствии разрешений пользователя для перехода по URLр
 *
 *
 * Для использования guard'а нужно указать для Route в данных свойство permissions со значением разрешений.
 */
@Injectable()
export class CheckPermissionsGuardService implements CanActivate {

    constructor(
        private authService: AuthService,
        private router: Router,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const permissions: UserNamespace.Permission[] = route.data['permissions'] || [];
        const fallbackUrl: string = route.data['fallbackUrl'] || '/';
        const byRelative = route.data['fallbackByRelative'] || false;

        if (!this.authService.hasPermissions(permissions)) {
            if (byRelative) {
                this.router.navigate([this.parseUrl(state.url, fallbackUrl)]);
            } else {
                this.router.navigate([fallbackUrl]);
            }
            return false;
        }

        return true;
    }

    /**
     * Преобразование абсолютного урла в относительный, путем слияния с redirectTo
     * parseUrl('/foo/bar/baz', './qux') => /foo/bar/baz/qux
     * parseUrl('/foo/bar/baz', '../qux') => /foo/bar/qux
     * parseUrl('/foo/bar/baz', '../../qux') => /foo/qux
     * parseUrl('/foo/bar/baz', '..') => /foo/bar
     *
     * https://github.com/angular/angular/issues/22763
     * @param url
     * @param redirectTo
     */
    private parseUrl(url: string, redirectTo: string) {
        const urlTokens = url.split('/');
        const redirectToTokens = redirectTo.split('/');

        let token = redirectToTokens.shift();

        while (token) {
            if (token !== '.' && token !== '..') {
                redirectToTokens.unshift(token);
                break;
            }

            if (token === '..') {
                urlTokens.pop();
            }

            token = redirectToTokens.shift();
        }

        urlTokens.push(...redirectToTokens);

        return urlTokens.join('/');
    }
}
